import React from 'react';
import { getString, languageChangeEvent } from '@nackle/intl-tools';

// Helper component for dynamic translation with fallback
export default class AltLocaleString extends React.Component {
    state = { value: getString( this.props.code ) };
    handler = () => {
        this.setState( { value: getString( this.props.code ) } );
    };
    componentDidMount() {
        if ( languageChangeEvent.on ) {
            languageChangeEvent.on( this.handler );
        }
    }
    componentWillUnmount() {
        if ( languageChangeEvent.off ) {
            languageChangeEvent.off( this.handler );
        }
    }
    componentDidUpdate( prevProps ) {
        if ( prevProps.code !== this.props.code ) {
            this.setState( { value: getString( this.props.code ) } );
        }
    }
    render() {
        return this.props.children( this.state.value || '' );
    }
}
